<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm35.516 10.664a1 1 0 011 1v24.34a1 1 0 01-1 1H38.74a1 1 0 01-1-1V19.657l-2.944 2.162a.5.5 0 01-.796-.403V18.9a1 1 0 01.41-.808l3.066-2.236a1 1 0 01.59-.192h2.45z"/></svg>
</template>
<script>

export default {
  name: 'IconH1',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
